import RenderAttribute from "components/PayoutManagement/previews/RenderAttribute";
import { PayoutMethodType } from "containers/PayoutManagement/types";

interface IVenmoPreviewProps {
  defaultPayoutMethod: PayoutMethodType;
}

const VenmoPreview: React.FC<IVenmoPreviewProps> = ({
  defaultPayoutMethod,
}) => {
  return (
    <>
      <RenderAttribute
        label={"Username: "}
        value={defaultPayoutMethod.username}
      />
      <RenderAttribute
        label={"Last 4 digit of phone number: "}
        value={defaultPayoutMethod.phoneNumberLast4}
      />
    </>
  );
};

export default VenmoPreview;
